module.exports = __webpack_public_path__ + "static/media/pilcrow.2e1874b3.svg";